export default __webpack_public_path__ + "static/media/art-red-1.90df8a28.png";